import { useDataSubmit, useDataIsSubmitting } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'automation',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'update' })
  }
}

export function useIsDisabled(props) {
  let isSubmitting = useDataIsSubmitting({
    viewPath: props.viewPath,
    context: 'automation',
  })

  return isSubmitting
}
